/*
 reportTransitionDialog

 This component represents the transition dialog.

 */

import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import { errorHandler } from '../common';
import { reportFiltersEditor, uiFiltersToAPIFilters } from '../filters';
import { reportsRepo } from './reportsRepo';

ko.components.register('report-transition-dialog', {
    viewModel: reportTransitionDialog,
    template: {
        element: 'report-transition-dialog-template'
    }
});

export function reportTransitionDialog(params) {

    var self = this;

    params = params || {};

    var data = params && params.data ? params.data : params;

    if (data instanceof reportTransitionDialog)
        return data;


    self.allReports = ko.observableArray([]);

    self.jumpToReport = function () {

        if (_.isFunction(self.transitionToReportCallback)) {

            if (self.reportId() === -1) {
                self.validationErrorsExist(true);
                return;
            }

            if (!self.reportFiltersEditor().filtersAreValid())
                return;

            var reportFilters = uiFiltersToAPIFilters(self.reportFiltersEditor().getFilters());

            self.transitionToReportCallback(self.reportId(), reportFilters);
        }
    }

    self.reportIdChanged = function () {

        //The report dropdown changed, so clear the errors flag
        self.validationErrorsExist(false);
    }

    self.validationErrorsExist = ko.observable(false);
    self.reportId = ko.observable(-1);
    self.reportFiltersEditor = ko.observable(new reportFiltersEditor());
    self.getReportsDataPromise = data.getReportsDataPromise;
    self.getReportsDataPromiseArgs = data.getReportsDataPromiseArgs;
    self.getReportColumnsDataPromise = data.getReportColumnsDataPromise;
    self.getReportColumnsDataPromiseArgs = data.getReportColumnsDataPromiseArgs;
    self.getReportFiltersDataPromise = data.getReportFiltersDataPromise;
    self.getReportFiltersDataPromiseArgs = data.getReportFiltersDataPromiseArgs;
    self.onLoadFailedCallback = data.onLoadFailedCallback;
    self.transitionToReportCallback = data.transitionToReportCallback;

    var init = function () {

        //Call the promise functions to get columns and filters
        if (_.isFunction(self.getReportsDataPromise) && _.isFunction(self.getReportsDataPromise().then)) {

            //Get the data
            $.when(
                self.getReportsDataPromise.apply(null, self.getReportsDataPromiseArgs)).then(
                    function (reports) {

                        self.allReports(ko.mapping.fromJS(reports)());

                        //Add properties to filters editor
                        self.reportFiltersEditor(
                            new reportFiltersEditor({
                                getReportColumnsDataPromise: self.getReportColumnsDataPromise,
                                getReportColumnsDataPromiseArgs: self.getReportColumnsDataPromiseArgs,
                                getReportFiltersDataPromise: self.getReportFiltersDataPromise,
                                getReportFiltersDataPromiseArgs: self.getReportFiltersDataPromiseArgs,
                                getListOfValuesColumnsDataPromise: function () {
                                    var deferred = $.Deferred();

                                    reportsRepo.getListOfValuesColumns().then(
                                        function (result) {
                                            deferred.resolve(result);
                                        },
                                        function (xhr) {
                                            errorHandler.processResponse(xhr);
                                            deferred.reject(xhr);
                                        });

                                    return deferred.promise();
                                },
                                onLoadFailedCallback: self.onLoadFailedCallback,
                                deleteOnly: false
                            }));
                    },
                    function (xhr) {
                        if (_.isFunction(self.onLoadFailedCallback)) {
                            self.onLoadFailedCallback.apply(null, [xhr]);
                        }
                    }
                );
        }
    }

    init();
}